import { useContext, useEffect, useState } from "react";
import { createNewThread, fetchThread } from "../services/api";
import { ThreadContext } from "../context/ThreadContext";


export const useThread = (requestState, setRequestState) => {
    const [threadId, setThreadId] = useState(undefined);
    const [messages, setMessages] = useState([]);
    const { updateThreadList } = useContext(ThreadContext);

    useEffect(() => {
        if (threadId !== undefined) return;

        let cancelled = false;

        const createConversation = async () => {
            try {
                setRequestState({ status: "in_progress" });
                const data = await createNewThread();
                if (cancelled) return;
                setThreadId(data.thread_id);
                localStorage.setItem("thread_id", data.thread_id);
                setRequestState(data);
                updateThreadList();
            } catch (error) {
                console.error(error);
                if (!cancelled) setRequestState({ status: "failed" });
            }
        };

        const restoreOrCreate = async () => {
            const storedId = localStorage.getItem("thread_id");
            if (!storedId || !storedId.startsWith("conv_")) {
                localStorage.removeItem("thread_id");
                await createConversation();
                return;
            }

            setRequestState({ status: "in_progress" });
            const data = await fetchThread(storedId);
            if (cancelled) return;

            if (data) {
                setThreadId(storedId);
                setRequestState(data);
            } else {
                localStorage.removeItem("thread_id");
                await createConversation();
            }
        };

        restoreOrCreate();
        return () => {
            cancelled = true;
        };
    }, [threadId, setRequestState, updateThreadList]);

    useEffect(() => {
        if (requestState?.messages) {
            setMessages(requestState.messages);
        }
    }, [requestState]);

    useEffect(() => {
        if (!threadId || !threadId.startsWith("conv_")) return;
        fetchThread(threadId).then((data) => {
            if (data) setRequestState(data);
        });
    }, [threadId, setRequestState]);

    const appendOptimisticMessage = (content) => {
        setMessages((current) => [
            ...current,
            {
                id: `optimistic-${Date.now()}`,
                content,
                role: "user",
                hidden: false,
                created_at: Date.now(),
            },
        ]);
    };

    const appendErrorMessage = () => {
        setMessages((current) => [
            ...current,
            {
                id: `error-${Date.now()}`,
                content: "The assistant is temporarily unavailable. Please try again.",
                role: "assistant",
                hidden: false,
                created_at: Date.now(),
            },
        ]);
    };

    const clearThread = () => {
        localStorage.removeItem("thread_id");
        setThreadId(undefined);
        setRequestState(undefined);
        setMessages([]);
    };

    return {
        threadId,
        setThreadId,
        messages,
        appendOptimisticMessage,
        appendErrorMessage,
        clearThread,
        updateThreadList,
    };
};
